// React dependencies
import React from 'react';

// External dependencies
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';

// Internal dependencies
import MButton from '../../../../components/MButton';
import Colours from '../../../../styles/colours';
import { IsEmpty } from '../../../../common/checks';

const useStyles = makeStyles((theme) => ({
  button: {
    // maxWidth:                       300,
    // [theme.breakpoints.down('sm')]: {
    //   maxWidth: 120,
    // },
  },
}));

const PoiButton = (props) => {
  const classes = useStyles();

  return (
    <MButton
      className={`${!IsEmpty(props.className) ? `${props.className}` : ' py-2 px-5'} ${classes.button}`}
      text={props.text}
      variant="outlined"
      textSize={props.textSize}
      textColour={props.disabled ? Colours.LightGray2 : Colours.Gray}
      textSemibold
      textStyle={{
        ...props.textStyle,
      }}
      style={{
        minHeight:    '2rem',
        borderColor:  props.disabled ? Colours.LightGray2 : Colours.Gray1,
        borderRadius: 8,
        borderStyle:  'solid',
        borderWidth:  1,
        ...props.style,
      }}
      onClick={props.onClick}
      disabled={props.disabled}
    />
  );
};

PoiButton.propTypes = {
  className: PropTypes.string,
  disabled:  PropTypes.bool,
  onClick:   PropTypes.func,
  textSize:  PropTypes.number,
  textStyle: PropTypes.shape({}),
  style:     PropTypes.shape({}),
  text:      PropTypes.string.isRequired,
};

PoiButton.defaultProps = {
  className: null,
  disabled:  false,
  onClick:   () => {},
  textSize:  12,
  textStyle: {},
  style:     {},
};

export default PoiButton;
